import * as $ from 'jquery';

import viewportTracker from '../lib/ViewportTracker';

// Collapsible Group
const availableAccordion = $(".filters");

if(availableAccordion.length !== 0) {
	const openOrClose = ($curr: JQuery, newOpen: boolean, addSlideProps: any = {}) => {
		const currentOpen = $curr.hasClass("active");
		const slideProps = {
			start: () => {
				$curr.trigger("changeStateBefore", {$curr, newOpen, currentOpen});
			},
			done: () => {
				$curr.trigger("changeStateAfter", {$curr, newOpen, currentOpen});
			},
			...addSlideProps
		};
		if (newOpen) {
			// Open
			$curr.addClass("active").find(".item__form").slideDown(slideProps);
		} else {
			// Close
			$curr.removeClass("active").find(".item__form").slideUp(slideProps);
		}
	}

	// Listeners
	// When Heading is Clicked
	$('.filters__items .item__heading, .filtersPageOverlay').on( "click" , function( event ) {
		const itemId = $(this).parent().attr('data-item-id');
		availableAccordion.trigger("changeActive", {itemId});
	});
	// On Page Load
	$(window).on('load', function(event) {
		availableAccordion.trigger("changeActiveOnScreenChange");
	});
	// On Screen Resize
	$(window).on('resize', function(event) {
		availableAccordion.trigger("changeActiveOnScreenChange");
	});

	// Open/Close - Updates 'Active' Accordion
	availableAccordion.on("changeActive", function(event, data) {
		const updateActiveAccordion = availableAccordion.find(".item");

		for (let i = 0; i < updateActiveAccordion.length; i++) { 
			const $curr = $(updateActiveAccordion[i]);
			// Open only if current item and not already open.
			const currentOpen = $curr.hasClass("active");
			let newOpen = false;
			if (data.itemId === updateActiveAccordion[i].dataset.itemId) {
				// Accordion changing to. If open value provided then use it.
				newOpen = data.open !== undefined ? data.open : !currentOpen;
			}

			openOrClose($curr, newOpen);
		}
	});

	// Modified accordions as switch between mobile and not mobile
	let isDesktopLastCheck:boolean = undefined;
	const updateOpenCloseOnLoadAndResize = function() {
		const isDesktop = $(window).width() > viewportTracker.getPixelSize('mobileMenu');

		// Protect against logic running unneedingly
		if (isDesktopLastCheck === isDesktop) {
			return;
		}
		isDesktopLastCheck = isDesktop;

		const updateActiveAccordion = availableAccordion.find(".item");

		for (let i = 0; i < updateActiveAccordion.length; i++) { 
			const $curr = $(updateActiveAccordion[i]);
			let newOpen = isDesktop && $curr.hasClass('item--alwaysOpenAboveMobile');
			openOrClose($curr, newOpen, {duration: 0});
		}
	};
	availableAccordion.on("changeActiveOnScreenChange" , updateOpenCloseOnLoadAndResize);
	
	// On Page Load - Close all accoridons, unless suppose to be open at desktop size (and is desktop)
	updateOpenCloseOnLoadAndResize();

}